import { useEffect } from "react";
import GreenvilleSCHeroSection from "./components/HeroSection";
import GreenvilleSCStickyNav from "./components/StickyNav";
import GreenvilleSCProcessingTimeSection from "./components/ProcessingTimeSection";
import GreenvilleSCServicesSection from "./components/ServicesSection";
import GreenvilleSCLocalAreaSection from "./components/LocalAreaSection";
import GreenvilleSCTestimonialsSection from "./components/TestimonialsSection";
import GreenvilleSCAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import GreenvilleSCComparisonSection from "./components/ComparisonSection";
import GreenvilleSCMistakesSection from "./components/MistakesSection";
import GreenvilleSCHowItWorksSection from "./components/HowItWorksSection";
import GreenvilleSCFAQSection, { faqs } from "./components/FAQSection";
import GreenvilleSCHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import GreenvilleSCFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function GreenvilleSCPage() {
  useEffect(() => {
    document.title = "Emergency & Expedited Passport Greenville SC | Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/greenville-sc/";
    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Greenville, SC — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Greenville, Spartanburg, Simpsonville, Mauldin, Greer, and all of Upstate South Carolina.");
    setMeta("geo.placename", "Greenville, South Carolina");
    setMeta("geo.region", "US-SC");
    setMeta("geo.position", "34.8526;-82.3940");
    setMeta("ICBM", "34.8526, -82.3940");
    setMeta("keywords", "expedited passport Greenville SC, emergency passport Greenville South Carolina, fast passport Upstate SC, passport renewal Greenville");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "South Carolina", item: "https://fastpassportcenter.com/south-carolina/" },
          { "@type": "ListItem", position: 3, name: "Greenville Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for Greenville and Upstate South Carolina travelers.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Greenville", containedInPlace: { "@type": "State", name: "South Carolina" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    document.getElementById("structured-data")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <GreenvilleSCHeroSection />
      <GreenvilleSCStickyNav />
      <GreenvilleSCProcessingTimeSection />
      <GreenvilleSCServicesSection />
      <GreenvilleSCLocalAreaSection />
      <GreenvilleSCTestimonialsSection />
      <GreenvilleSCAcceptanceFacilitiesSection />
      <GreenvilleSCComparisonSection />
      <GreenvilleSCMistakesSection />
      <GreenvilleSCHowItWorksSection />
      <GreenvilleSCFAQSection />
      <GreenvilleSCHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/greenville-sc" state="SC" />
      <GreenvilleSCFinalCTA />
    </div>
  );
}